import React from "react";
import MiniHero from "components/miniHero";

const Booking: React.FC = () => {
  return (
    <div>
      <MiniHero image="/images/Gallery/DSC00119.jpg" text="Boka" />

      {/* Main Content Section */}
      <div className="container mx-auto mt-8 px-8 lg:px-20 py-8">
        <div className="flex flex-col items-center gap-16">
          {/* Left Column - Text Content */}
          <div className="w-full md:w-3/4 text-left">
            <h1
              className="text-4xl font-bold text-gray-800 mb-6"
              style={{ fontFamily: "'Bebas Neue', sans-serif" }}
            ></h1>
            {/* Introduction */}
            <p
              className="text-lg text-gray-600 mb-6"
              style={{ fontFamily: "'IBM Plex Mono', monospace" }}
            >
              På denna sidan kan du boka både gruppträning och massage för att
              uppnå dina hälsomål och ta hand om din kropp.
            </p>

            {/* Group Training Section */}
            <div className="mb-8">
              <h2
                className="text-2xl font-semibold text-gray-800 mb-4"
                style={{ fontFamily: "'Bebas Neue', sans-serif" }}
              >
                Gruppträning
              </h2>
              <p
                className="text-lg text-gray-600 mb-4"
                style={{ fontFamily: "'IBM Plex Mono', monospace" }}
              >
                Våra gruppträningar är designade för att ge dig en
                helkroppsträning som både utmanar och inspirerar. Varje pass är
                noggrant utformat för att vara varierande och roligt, samtidigt
                som du får en effektiv och allsidig träning.
              </p>
              <p
                className="text-lg text-gray-600"
                style={{ fontFamily: "'Bebas Neue', sans-serif" }}
              >
                Träningsschema:
              </p>
              <ul
                className="list-disc list-inside text-lg text-gray-600 mb-6"
                style={{ fontFamily: "'IBM Plex Mono', monospace" }}
              >
                <li>Måndag: 18:00–19:00</li>
                <li>Torsdag: 18:00–19:00</li>
                <li>Söndag: 17:00–18:00</li>
              </ul>
            </div>

            {/* Massage Section */}
            <div className="mb-8">
              <h2
                className="text-2xl font-semibold text-gray-800 mb-4"
                style={{ fontFamily: "'Bebas Neue', sans-serif" }}
              >
                Massage
              </h2>
              <p
                className="text-lg text-gray-600"
                style={{ fontFamily: "'IBM Plex Mono', monospace" }}
              >
                Ge din kropp den omtanke den förtjänar med en avkopplande och
                återhämtande massage. Perfekt för att lösa upp spänningar efter
                träning, minska stress, eller bara unna dig själv en stund av
                välbehövlig återhämtning.
              </p>
            </div>

            {/* Booking Button */}
            <div
              className="text-center my-16"
              style={{ fontFamily: "'IBM Plex Mono', monospace" }}
            >
              <a
                href="https://www.bokadirekt.se/places/lada-basteskar-60229"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-darkBlue text-white font-semibold py-3 px-8 rounded-md hover:bg-hoverBlue transition duration-200"
              >
                Boka Nu
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Booking;
